<studio-button-legacy [theme]="buttonTheme || fallbackButtonTheme" [disabled]="disabled">
  {{ text }}
</studio-button-legacy>
